let activeModal;

function init() {
	const $modals = $('.modal:not([data-modal-init="true"]');
	const $modalTriggers = $('[data-modal]:not([data-modal-init="true"])');

	$modals.each(function (e) {
		const $modal = $(this);
		const $modalContent = $modal.find('.modal__content');

		$modal.attr('data-modal-init', true);

		// Create a new timeline
		const timeline = gsap.timeline({
			paused: true,
			onStart: () => {
				$modal.data('isOpen', true);
				activeModal = $modal;

				disableScroll();
			},
			onReverseComplete: () => {
				$modal.data('isOpen', false);
				activeModal = null;

				enableScroll();
			}
		});

		// Animate the modal
		timeline.to(
			$modal,
			{
				duration: 0.3,
				autoAlpha: 1
			},
			0
		);

		// Animate the modal content
		timeline.to(
			$modalContent,
			{
				duration: 0.3,
				scale: 1
			},
			0
		);

		// Store modal data
		$modal.data('timeline', timeline);
		$modal.data('isOpen', false);

		// Add listener to close modal (on bg click)
		$modal.click(function (e) {
			if (e.target.classList.contains('modal')) {
				closeModal($modal);
			}
		});
	});

	$modalTriggers.each(function (e) {
		const $trigger = $(this);
		const $modal = $($trigger.data('modal'));

		$trigger.attr('data-modal-init', true);

		$trigger.click(function (e) {
			e.preventDefault();

			toggleModal($modal);
		});
	});
}

// Func
// ----------------------------------------

function closeModal($modal) {
	if (!$modal.length) return;

	$modal.data('timeline').reverse();

	const $iframe = $modal.find('iframe[data-src]');

	if ($iframe.length) {
		$iframe.attr('src', '');
	}
}

function openModal($modal) {
	if (!$modal.length) return;

	$modal.data('timeline').play();

	const $iframe = $modal.find('iframe[data-src]');

	if ($iframe.length) {
		$iframe.attr('src', $iframe.attr('data-src'));
	}
}

function toggleModal($modal) {
	if (!$modal.length) return;

	if ($modal.data('isOpen')) {
		closeModal($modal);
	} else {
		openModal($modal);
	}
}

// Events
// ----------------------------------------

$WINDOW.on('load', () => {
	init();
});

$BODY.keydown((e) => {
	if (activeModal && e.keyCode === 27) {
		closeModal(activeModal);
	}
});

$WINDOW.on('page:load-started', (e) => {
	if (activeModal) {
		closeModal(activeModal);
	}
});

$WINDOW.on('page:load-completed', (e) => {
	init();
});
